var map = {
	"./m/screen1.png": 486,
	"./m/screen2.png": 487,
	"./m/screen3.png": 488,
	"./m/screen4.png": 489,
	"./m/screen5.png": 490,
	"./m/screen6.png": 491,
	"./m/screen7.png": 492,
	"./m/screen8.png": 493,
	"./o/screen1.png": 494,
	"./o/screen2.png": 495,
	"./o/screen3.png": 496,
	"./o/screen4.png": 497,
	"./o/screen5.png": 498,
	"./o/screen6.png": 499,
	"./o/screen7.png": 500,
	"./o/screen8.png": 501,
	"./s/screen1.png": 502
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 485;